<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-cube', fontSet: 'fad'}"
	[headerText]="data.trainingRoom.name + (T.CONFIGURATION_EDITOR_TRAINING_ROOM_RECORDER_SELECTION_DIALOG_TITLE | translate)"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<ng-container>
			<sim-admin-settings-scroll-entries-con
				[getScrollEntryText]="getRecorderName"
				(removeEntryEmitter)="removeRecorder($event)"
				[scrollEntries]="usedRecorderList ?? filterUsedRecorderList()"
			>
				<mat-form-field color="accent" style="width: 100%; justify-items: center">
					<mat-label>{{ T.CONFIGURATION_EDITOR_TRAINING_ROOM_RECORDER_SELECTION_DIALOG_RECORDERS | translate }}</mat-label>
					<mat-select
						(ngModelChange)="addRecorder($event, data.trainingRoom.recorderMappingIds)"
						[(ngModel)]="selectedRecorderId"
					>
						@for (recorder of availableRecorderList ?? filterAvailableRecorderList(); track recorder) {
							<mat-option [value]="recorder.id">
								{{ recorder.name }}
							</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</sim-admin-settings-scroll-entries-con>
		</ng-container>
	</ng-container>

	<ng-container actions>
		<sim-button (onClick)="ok()" [icon]="{fontSet: 'fad', fontIcon: 'fa-check'}" [label]="T.BUTTON_OK" color="accent" />
	</ng-container>
</sim-basic-material-dialog>
